
import React, { useState } from 'react';
import { RoleTrack } from '../types';
import { SKILL_MAPS } from '../constants';

const SkillMap: React.FC = () => {
  const [activeTrack, setActiveTrack] = useState<RoleTrack>(RoleTrack.OPS);

  return (
    <section id="skill-maps" className="py-20 px-6 max-w-7xl mx-auto">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
        <div>
          <h2 className="text-3xl font-bold mb-2">Technical Skill Maps</h2>
          <p className="text-slate-400">Concrete milestones for specific AWS domains.</p>
        </div>
        <div className="flex flex-wrap gap-2 p-1 bg-slate-900 rounded-xl border border-slate-800">
          {Object.values(RoleTrack).map((track) => (
            <button
              key={track}
              onClick={() => setActiveTrack(track)}
              className={`px-4 py-2 rounded-lg text-sm font-semibold transition-all ${
                activeTrack === track 
                  ? 'bg-orange-500 text-white shadow-lg' 
                  : 'text-slate-400 hover:text-white'
              }`}
            >
              {track}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {SKILL_MAPS[activeTrack].map((skill, index) => (
          <div 
            key={index} 
            className="glass p-8 rounded-2xl relative overflow-hidden group hover:border-orange-500/30 transition-all"
          >
            <div className="absolute top-0 right-0 p-4 opacity-10 font-black text-6xl group-hover:opacity-20 transition-opacity">
              {index + 1}
            </div>
            <div className="inline-block px-3 py-1 bg-slate-800 rounded-md text-xs font-mono text-orange-400 mb-4">
              {skill.level}
            </div>
            <h3 className="text-xl font-bold mb-4">{skill.title}</h3>
            <p className="text-slate-400 mb-6 text-sm leading-relaxed">
              {skill.description}
            </p>
            <div className="flex flex-wrap gap-2">
              {skill.tags.map(tag => (
                <span key={tag} className="px-2 py-1 bg-slate-800 border border-slate-700 rounded text-[10px] font-mono uppercase text-slate-300">
                  {tag}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SkillMap;
